<template>
  <div class="main" v-if="!loadPage">

    <h1>Live</h1>
    <b-card-group deck>
      <b-card class="general" >
        <luma-cpu-ram-live-line-chart :activated="activated"></luma-cpu-ram-live-line-chart>
      </b-card>
      <chart-overview-vserver category="Traffic"
                              datasetA="netin"
                              datasetB="netout"
                              options="trafficPie"
                              :backgroundColor="['rgba(175, 200, 128, 0.2)','rgb(175, 223, 128)']"
                              :label="['IN','OUT']">
      </chart-overview-vserver>
      <chart-overview-vserver category="Data"
                              datasetA="diskread"
                              datasetB="diskwrite"
                              options="trafficPie"
                              :backgroundColor="['rgba(54, 162, 235, 0.2)','rgba(54, 162, 235, 1)']"
                              :label="['READ','WRITE']">
      </chart-overview-vserver>
    </b-card-group>
    <hr>


    <h1>Historie</h1>
    <luma-time-chart-controller></luma-time-chart-controller>
    <b-card-group deck class="mb-4">
      <b-card >
        <luma-vserver-main-chart catkey="RAM"
                                 category="mem"
                                 :show-capacity="true">
        </luma-vserver-main-chart>
      </b-card>
      <b-card>
        <luma-vserver-main-chart catkey="CPU"
                                 category="cpu">
        </luma-vserver-main-chart>
      </b-card>
    </b-card-group>
    <b-card-group deck>
      <b-card>
        <luma-vserver-main-chart catkey="Netzwerk"
                                 category="netin">
        </luma-vserver-main-chart>
      </b-card>
      <b-card>
        <luma-vserver-main-chart catkey="Schreiben"
                                 category="diskwrite"
                                  sec_catkey="Lesen"
                                  sec_category="diskread">
        </luma-vserver-main-chart>
      </b-card>
    </b-card-group>
<!--    <b-card-group deck class="mb-4">-->
<!--      <b-card>-->
<!--        <luma-ram-line-chart ></luma-ram-line-chart>-->
<!--      </b-card>-->
<!--      <b-card>-->
<!--        <luma-net-line-chart></luma-net-line-chart>-->
<!--      </b-card>-->
<!--    </b-card-group>-->
<!--    <b-card-group deck >-->
<!--      <b-card>-->
<!--        <luma-read-write-line-chart></luma-read-write-line-chart>-->
<!--      </b-card>-->
<!--      <b-card>-->
<!--        <luma-cpu-line-chart></luma-cpu-line-chart>-->
<!--      </b-card>-->
<!--    </b-card-group>-->

  </div>
</template>

<script>
  import {PageControl} from "@/store/models/layout/page_control";
  import ChartControllerVserver from "@/components/charts/chart-controller-vserver";
  import ChartOverviewVserver from "@/components/charts/chart-overview-vserver";
  import ChartStatusVserver from "@/components/charts/chart-status-vserver";
  import {VserverGraph} from "@/store/models/vserver/vserver_graph";
  import LumaTimeChartController from "@/components/vserver_charts/luma-time-chart-controller";
  import LumaCpuRamLiveLineChart from "@/components/vserver_charts/luma-cpu-ram-live-line-chart";
  import LumaVserverMainChart from "../../vserver_charts/luma-vserver-main-chart";


  export default {
    name: "luma-status-vserver",
    props:{
      activated:Boolean,
      vid:String,
      loadPage:Boolean
    },
      data:()=>({
         showCapacity:true
      }),
    components: {
        LumaVserverMainChart,
      LumaCpuRamLiveLineChart,
      // LumaCpuLineChart,
      // LumaReadWriteLineChart,
      LumaTimeChartController,
      // LumaNetLineChart,
      // LumaRamLineChart,
      ChartStatusVserver,
      ChartOverviewVserver,
      ChartControllerVserver
    },
    computed:{
        path(){
          return this.$route.name
        },
        chartObject(){
            const x = Chart.instances
            return x
        },
        pageControl(){
          if(!PageControl.find(this.path)) return
          return PageControl.find(this.path) || undefined
        },

        graphs(){
            return VserverGraph.modelNames(this.vid) || undefined
        },
        apiCalls(){
            return this.graphs.map(el=>el.split('_'))
        }
    },
    created(){

    }
  }
</script>

<style scoped>
  .general{
    min-width: 200px ;
    height: 230px;
  }
  .card-deck{
    min-width: 700px;
  }

</style>




// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-status-vserver.vue